module.exports = __webpack_public_path__ + "static/chess-e95debdb90752e892ca974ea47e2c685.jpg";